import { useEffect, useState } from "react";
import { AuthData } from "../../../context/AuthWrapper";
import { dataGet, dataPut } from "../../../network";
import Input from "../../../component/items/Input";
// import Button from "../../../component/items/Button";
import Navbar from "../../../component/Navbar";
import { Button, Card, Typography } from "@material-tailwind/react";
import { Dialog } from "../../../component/items/Dialog";
import { dialogDataTypes } from "../../../component/items/itemDataType";
import {
  countryAutoComplete,
  profileInfo,
  profileUpdate,
} from "../../../network/const";
import { useNavigate } from "react-router-dom";
import SearchableSelect from "../../../component/items/SearchableSelect";

function MyProfile() {
  const navigate = useNavigate();
  const authData = AuthData();
  const user = authData?.identity;
  const [open, setOpen] = useState(false);
  const [dialogData, setDialogData] = useState<dialogDataTypes>({
    title: "",
    btnText: "",
    description: "",
    status: false,
  });

  const [countries, setCountries] = useState<
    { countryId: string; countryName: string }[]
  >([]);

  const [formState, setFormState] = useState({
    userName: "",
    email: "",
    jobTitle: "",
    companyName: "",
    countryName: "",
    countryId: "",
  });

  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  useEffect(() => {
    const init = async () => {
      const countriesRes = await dataGet(countryAutoComplete, {});
      if (countriesRes.status) {
        setCountries(countriesRes.data);

        const profileRes = await dataGet(profileInfo, {});
        if (profileRes.status) {
          setFormState({
            userName: profileRes.data.username ?? "",
            email: profileRes.data.email ?? "",
            jobTitle: profileRes.data.jobTitle ?? "",
            companyName: profileRes.data.companyName ?? "",
            countryName: profileRes.data.countryName?.toString() ?? "",
            countryId: profileRes.data.countryId?.toString() ?? "",
          });
        }
      }
    };
    init();
  }, []);

  // useEffect(() => {
  //   const init = async () => {
  //     // await fetchCountries();
  //     await fetchProfileData();
  //   };
  //   init();
  // }, []);

  // const fetchCountries = async () => {
  //   const res = await dataGet(countryAutoComplete, {});
  //   if (res.status) {
  //     setCountries(res.data);
  //   }
  // };

  // const fetchProfileData = async () => {
  //   const res = await dataGet(profileInfo, {});
  //   if (res.status) {
  //     // wait until countries are loaded
  //     if (countries.length === 0) {
  //       await fetchCountries(); // ensure countries are loaded first
  //     }

  //     setFormState({
  //       userName: res.data.username ?? "",
  //       email: res.data.email ?? "",
  //       jobTitle: res.data.jobTitle ?? "",
  //       companyName: res.data.companyName ?? "",
  //       countryName: res.data.countryName?.toString() ?? "",
  //       countryId: res.data.countryId?.toString() ?? "",
  //     });
  //   }
  // };

  const initDialog = (data: dialogDataTypes) => {
    setOpen(true);
    setDialogData({
      title: data.title,
      btnText: data.btnText,
      description: data.description,
      status: data.status ?? false,
    });
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFormState({ ...formState, [e.target.name]: e.target.value });
  };

  const validate = () => {
    const newErrors: { [key: string]: string } = {};
    let isValid = true;

    if (!formState.userName) {
      newErrors.userName = "User Name is required.";
      isValid = false;
    }

    if (!formState.email || !/\S+@\S+\.\S+/.test(formState.email)) {
      newErrors.email = "Valid email is required.";
      isValid = false;
    }

    if (user?.role === "User") {
      if (!formState.jobTitle) {
        newErrors.jobTitle = "Job Title is required.";
        isValid = false;
      }
      if (!formState.companyName) {
        newErrors.companyName = "Company Name is required.";
        isValid = false;
      }
      if (!formState.countryId) {
        newErrors.countryId = "Country is required.";
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validate()) return;

    const payload: any = {
      userName: formState.userName,
    };

    if (user?.role === "User") {
      payload.jobTitle = formState.jobTitle;
      payload.companyName = formState.companyName;
      payload.countryId = formState.countryId;
    }

    const data = await dataPut(profileUpdate, payload, { silent: false });
    initDialog({
      description: data.message,
      title: data.title,
      btnText: "OK",
      status: data.status,
    });
  };

  return (
    <>
      <Navbar />
      <div className="mt-20">
        <Card color="transparent" className="items-center" shadow={false}>
          <Typography variant="h4" color="blue-gray">
            My Profile
          </Typography>
          <form
            className="mt-8 mb-2 p-5 max-w-screen-lg w-full"
            onSubmit={handleSubmit}
          >
            <div className="max-w-2xl mx-auto p-6 bg-white rounded shadow">
              <Input
                labelText="User Name"
                labelFor="userName"
                id="userName"
                name="userName"
                type="text"
                value={formState.userName}
                handleChange={handleChange}
                isRequired
                placeholder="User Name"
                customClass={""}
              />
              {errors.userName && (
                <span className="text-red-600 text-sm">
                  * {errors.userName}
                </span>
              )}

              <Input
                labelText="Email"
                labelFor="email"
                id="email"
                name="email"
                type="email"
                value={formState.email}
                handleChange={() => {}}
                isRequired={false}
                disabled
                placeholder="Email"
                customClass={""}
              />
              {errors.email && (
                <span className="text-red-600 text-sm">* {errors.email}</span>
              )}

              {user?.role === "User" && (
                <>
                  <Input
                    labelText="Job Title"
                    labelFor="jobTitle"
                    id="jobTitle"
                    name="jobTitle"
                    type="text"
                    value={formState.jobTitle}
                    handleChange={handleChange}
                    isRequired
                    placeholder="Job Title"
                    customClass={""}
                  />
                  {errors.jobTitle && (
                    <span className="text-red-600 text-sm">
                      * {errors.jobTitle}
                    </span>
                  )}

                  <Input
                    labelText="Company Name"
                    labelFor="companyName"
                    id="companyName"
                    name="companyName"
                    type="text"
                    value={formState.companyName}
                    handleChange={handleChange}
                    isRequired
                    placeholder="Company Name"
                    customClass={""}
                  />
                  {errors.companyName && (
                    <span className="text-red-600 text-sm">
                      * {errors.companyName}
                    </span>
                  )}

                  {countries.length > 0 && (
                    // <Select
                    //   id="countryId"
                    //   name="countryId"
                    //   labelText="Country"
                    //   isRequired
                    //   value={formState.countryId}
                    //   placeholder="Country"
                    //   options={countries.map((c) => ({
                    //     label: c.countryName,
                    //     value: c.countryId.toString(),
                    //   }))}
                    //   handleChange={(value: string) => {
                    //     const selected = countries.find(
                    //       (c) => c.countryId.toString() === value
                    //     );
                    //     setFormState({
                    //       ...formState,
                    //       countryName: selected?.countryName || "",
                    //       countryId: selected?.countryId.toString() || "",
                    //     });
                    //   }}
                    // />
                    <SearchableSelect
                      id="country"
                      labelText="Country"
                      isRequired={true}
                      value={formState.countryId}
                      placeholder="Select Country"
                      options={countries.map((c) => ({
                        label: c.countryName,
                        value: c.countryId.toString(),
                      }))}
                      handleChange={(value: string) => {
                        const selected = countries.find(
                          (c) => c.countryId.toString() === value
                        );
                        setFormState({
                          ...formState,
                          countryName: selected?.countryName || "",
                          countryId: selected?.countryId.toString() || "",
                        });
                      }}
                    />
                  )}

                  {errors.countryId && (
                    <span className="text-red-600 text-sm">
                      * {errors.countryId}
                    </span>
                  )}
                </>
              )}
              <div className="flex space-x-2">
                <Button className="mt-6" fullWidth onClick={() => navigate(-1)}>
                  Cancel
                </Button>
                <Button
                  className="mt-6"
                  color="green"
                  fullWidth
                  onClick={handleSubmit}
                >
                  Update Profile
                </Button>
              </div>
              {/* <div className="mt-6">
                <Button
                  action="submit"
                  handleSubmit={handleSubmit}
                  text="Update Profile"
                />
              </div> */}
            </div>
          </form>
        </Card>

        <Dialog
          open={open}
          handleOpen={() => setOpen(!open)}
          title={dialogData.title}
          description={dialogData.description}
          buttonText={dialogData.btnText}
        />
      </div>
    </>
  );
}

export default MyProfile;
